<div class="betslip-over-ask-pick">
    <div class="betslip-over-ask-pick__line-0">
        <span>{{ pick.optionName.name }}</span>
    </div>
    <div class="betslip-over-ask-pick__line-1">{{ marketName }}</div>
    <div class="betslip-over-ask-pick__line-2">
        <span>{{ pick.eventName.name }}</span>
        @if (shouldShowBadge) {
            <div class="betslip-over-ask-pick__market-badge">
                <span class="betslip-over-ask-pick__market_current_value">{{ getCounterOfferMarket() }}</span>
                <span class="betslip-over-ask-pick__market_prev_value">{{ getInitialMarket() }}</span>
            </div>
        }
    </div>
    <div class="betslip-over-ask-pick__changes">
        <ng-content select="[price-changes]" />
    </div>
    <div class="betslip-over-ask-pick__remove-container">
        <ng-content select="[remove-button]" />
    </div>
    <div class="betslip-over-ask-pick__winnings">
        <ng-content select="[multi-single-possible-winnings]" />
    </div>
</div>
